import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { UIComponentView } from '../uicomponentview';
import { PlayerView } from './playerview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { PlayerComponentCSSStyle } from './playercss';
import { BaseContext } from '../../../utils/basecontext';
import { RadialProgressBarCSSStyle } from '../radialprogressbar/radialprogressbarcss';

export interface PlayerComponentProps extends UIComponentProps
{
    isPlaying: boolean;
    id?: string;
    position?: number;
    playIconName: string;
    pauseIconName: string;
    isAutoPlayRequired?: boolean;
    playerCSSStyle: PlayerComponentCSSStyle;
    radialProgressBarCSSStyle?:RadialProgressBarCSSStyle;
    onPlayClicked(): void;
    onStopClicked(): void;
}

export interface PlayerComponentState extends UIComponentState
{
   isPlaying: boolean;
}

export interface PlayerComponentHandler extends UIComponentHandler
{
    onPlayClicked(): void;
    onStopClicked(): void;
    onPlayComplete(): void;
    onPlayStop(): void;

}

export class PlayerComponent extends UIComponentImpl<PlayerComponentProps, PlayerComponentState, UIDataModel>
   implements PlayerComponentHandler
{
    constructor(props: PlayerComponentProps)
    {
        super(props);
        
        this.state = {isPlaying: props.isPlaying};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PlayerView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.playerCSSStyle;
    }

    onPlayClicked(): void
    {
        this.setState({isPlaying: true});

        this.props.onPlayClicked();
    }

    onStopClicked(): void
    {
        this.setState({isPlaying: false});

        this.props.onStopClicked();
    }

    onPlayComplete(): void
    {
        this.setState({isPlaying: false});
    }

    onPlayStop(): void 
    {
        this.setState({isPlaying: false});
    }

    componentWillUnmount() 
    {
        this.getContext().getPlayerManager().release();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playercomponent.tsx